import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { password_edit_api, ResetPassword, Sources, User_Registration, User_Registration_v2 } from '../models/User';
import { PromiseResult } from '../models/PromiseResult';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { RestApi } from '../shared/apiUrls';
import { catchError } from 'rxjs/operators';
import { OTP_Validate } from '../models/util.models';
import { ForgotPassword, ForgotPasswordToken } from '../models/LoginUser';
import { VerifyUserID_Body } from '../models/Login';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    constructor(
        private readonly http: HttpClient
    ) { }


    createUser(user: User_Registration): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(RestApi.Urls.UserApi + 'Create', user)
            .pipe(catchError(this.handleError));
    }

    confirm_email(token: any): Observable<PromiseResult> {
        const body = { token: token };
        return this.http
            .post<PromiseResult>(RestApi.Urls.UserApi + 'ConfirmEmail', body)
            .pipe(catchError(this.handleError));
    }

    forgotEmail(user: User_Registration): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(RestApi.Urls.UserApi + 'ForgotEmail', user)
            .pipe(catchError(this.handleError));
    }

    forgotUserPassword(user: User_Registration): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.UserApi + 'SendResetPasswordToken',
                user
            )
            .pipe(catchError(this.handleError));
    }

    verifyUserID_Init(data: VerifyUserID_Body): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.UserApi + 'account/reconfirm',
                data
            )
            .pipe(catchError(this.handleError));
    }

    verifyUserID_validate_or_resend_otp_patient(data: OTP_Validate): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.UserApi + 'account/reconfirm/validate',
                data
            )
            .pipe(catchError(this.handleError));
    }

    resendToken(user: User_Registration): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.UserApi + 'ResendEmailConfirmation',
                user
            )
            .pipe(catchError(this.handleError));
    }

    UserCheck(user_guid: string): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(RestApi.Urls.UserApi + 'Exist/' + user_guid)
            .pipe(catchError(this.handleError));
    }

    GetUserData(user_guid: string): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(RestApi.Urls.UserApi + 'Get/' + user_guid)
            .pipe(catchError(this.handleError));
    }

    UpdateUserProfile(data: password_edit_api, user_guid: string): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.UserApi + 'Update/' + user_guid,
                data
            )
            .pipe(catchError(this.handleError));
    }

    UpdateUserProfilePhoto(
        form: FormData,
        user_guid: string
    ): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.UserApi + 'Update/ProfilePhoto/' + user_guid,
                form
            )
            .pipe(catchError(this.handleError));
    }

    fetchSources(): Observable<Sources[]> {
        return this.http
            .get<Sources[]>(RestApi.Urls.UserApi + 'fetch/sources')
            .pipe(catchError(this.handleError));
    }

    // -----------------------------------------------------------------------------------------

    resetPassword(Password: ResetPassword): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.ResetPasswordApi + 'ResetPassword',
                Password
            )
            .pipe(catchError(this.handleError));
    }

    register_patient_validate_or_resend_otp(data: OTP_Validate) {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.UserApi + 'account/validate',
                data
            )
            .pipe(catchError(this.handleError));
    }

    forgotPassword(body: ForgotPassword): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(RestApi.Urls.ResetPasswordApi + 'forgot', body)
            .pipe(catchError(this.handleError));
    }

    validateForgotPasswordToken(body: ForgotPasswordToken): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(RestApi.Urls.ResetPasswordApi + 'validate', body)
            .pipe(catchError(this.handleError));
    }

    updateCredentialsPatient(userid: string) {
        return this.http
            .post<PromiseResult>(RestApi.Urls.UserApi + 'update/credentials', { data: userid })
            .pipe(catchError(this.handleError));
    }

    credentials_validate_or_resend_otp_patient(data: OTP_Validate) {
        return this.http
            .post<PromiseResult>(RestApi.Urls.UserApi + 'update/credentials/validate', data)
            .pipe(catchError(this.handleError));
    }

    register_or_resend_otp_patient(data: User_Registration_v2) {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.UserApi +
                'v2/create',
                data
            )
            .pipe(catchError(this.handleError));
    }
}
